import { FC, useContext, useEffect, useMemo } from 'react';

import { CardCoverage } from './components';
import { QuotationInfoContext, SectionQuotation } from '../../../../../shared';
import { RowSize } from '../../../../../../../../../shared/components';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

interface CoveragesCarSectionProps {
  tabKey: number;
}

export const CoveragesCarSection: FC<CoveragesCarSectionProps> = ({
  tabKey,
}) => {
  const { getCoveragesPerVehicle } = useContext(WizardDataFormContext);
  const { autoSelectHighestPrizeCoverage } = useContext(StepThreeFormContext);
  const { loadSaveQuotationState } = useContext(QuotationInfoContext);
  const { quotationInfo } = useContext( QuotationInfoContext );

  const coveragesPerVehicle = useMemo(
    () => getCoveragesPerVehicle(String(tabKey)),
    [getCoveragesPerVehicle, tabKey]
  );

  useEffect(() => {
    if (coveragesPerVehicle?.length && !loadSaveQuotationState) {
      autoSelectHighestPrizeCoverage(String(tabKey));
    }
    /* eslint-disable-next-line */
  }, [coveragesPerVehicle, loadSaveQuotationState]);

  return (
    <>
      <SectionQuotation level='h3' title='Coberturas' hasCard={false}>
        <RowSize rowProps={{ gutter: [0, 15] }}>
          {coveragesPerVehicle?.map((coverage, index) => (
            <CardCoverage
              quotationInfo={quotationInfo}
              tabKey={tabKey}
              key={`${coverage.codigo}-${index}`}
              coverage={coverage}
            />
          ))}
        </RowSize>
      </SectionQuotation>
    </>
  );
};
